@use '../common/colors.scss' as colors;
@use '../common/vars' as vars;

.full-ssn-wrapper {
  display: flex;
  flex-direction: column;
  width: 66.6666%;
  max-width: 450px;
  margin: 0 auto;
  padding: 3rem 1rem;

  @media screen and (max-width: vars.$mobile) {
    width: 100%;
  }
}

.full-ssn-header {
  margin-bottom: 1.5rem;
  text-align: center;
}

.full-ssn-body {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
